export const INDIA_CITY_OPTIONS = [
  "Ahmedabad",
  "Aligarh",
  "Allahabad",
  "Amritsar",
  "Aurangabad",
  "Bangalore",
  "Bareilly",
  "Belgaum",
  "Bengaluru",
  "Bhopal",
  "Bhubaneswar",
  "Bikaner",
  "Bilaspur",
  "Chandigarh",
  "Chennai",
  "Coimbatore",
  "Cuttack",
  "Dehradun",
  "Delhi",
  "Dhanbad",
  "Dharamshala",
  "Durgapur",
  "Faridabad",
  "Ghaziabad",
  "Goa",
  "Gorakhpur",
  "Gurugram",
  "Guwahati",
  "Gwalior",
  "Haldwani",
  "Hubballi",
  "Hyderabad",
  "Imphal",
  "Indore",
  "Jabalpur",
  "Jaipur",
  "Jalandhar",
  "Jammu",
  "Jamnagar",
  "Jamshedpur",
  "Jhansi",
  "Jodhpur",
  "Kalyan",
  "Kanpur",
  "Karnal",
  "Kochi",
  "Kolkata",
  "Kota",
  "Kozhikode",
  "Lucknow",
  "Ludhiana",
  "Madurai",
  "Mangalore",
  "Meerut",
  "Moradabad",
  "Mumbai",
  "Mysore",
  "Nagpur",
  "Nashik",
  "Navi Mumbai",
  "Noida",
  "Panaji",
  "Patiala",
  "Patna",
  "Pune",
  "Raipur",
  "Rajahmundry",
  "Rajkot",
  "Ranchi",
  "Rohtak",
  "Saharanpur",
  "Salem",
  "Shimla",
  "Siliguri",
  "Srinagar",
  "Surat",
  "Thane",
  "Thiruvananthapuram",
  "Tiruchirappalli",
  "Tirunelveli",
  "Udaipur",
  "Ujjain",
  "Vadodara",
  "Varanasi",
  "Vellore",
  "Vijayawada",
  "Visakhapatnam",
  "Warangal",
  "Agra",
  "Ajmer",
  "Akola",
  "Aizawl",
  "Ambala",
  "Anand",
  "Asansol",
  "Bahraich",
  "Ballari",
  "Bhagalpur",
  "Bhavnagar",
  "Bhilai",
  "Bhilwara",
  "Bhiwandi",
  "Bhiwani",
  "Bokaro",
  "Burdwan",
  "Chittoor",
  "Dewas",
  "Erode",
  "Faizabad",
  "Firozabad",
  "Guntur",
  "Hisar",
  "Hosur",
  "Hubli",
  "Itanagar",
  "Jalgaon",
  "Jhunjhunu",
  "Kakinada",
  "Karimnagar",
  "Katihar",
  "Khammam",
  "Kolhapur",
  "Kottayam",
  "Kurnool",
  "Latur",
  "Mandsaur",
  "Margao",
  "Mathura",
  "Moga",
  "Muzaffarnagar",
  "Muzaffarpur",
  "Nagercoil",
  "Nanded",
  "Nizamabad",
  "Ongole",
  "Puducherry",
  "Puri",
  "Ratlam",
  "Sagar",
  "Sangli",
  "Satara",
  "Seoni",
  "Shivamogga",
  "Solapur",
  "Sriganganagar",
  "Sultanpur",
  "Tirupati",
  "Tumakuru",
  "Udupi",
  "Ulhasnagar",
  "Upleta",
  "Vapi",
  "Vasco da Gama",
  "Yamunanagar",
];
